import React, { useState } from "react";
import Heading from "@amzn/meridian/heading";
import Text from "@amzn/meridian/text";
import Box from "@amzn/meridian/box";
import Tab, { TabGroup } from "@amzn/meridian/tab";

import { SettingsTab } from "./types";
import OpsClockTab from "./tabs/OpsClockTab";
import BreaksTab from "./tabs/BreaksTab";
import WipSettingsTab from "./tabs/WipSettingsTab";
import IndirectHCTab from "./tabs/IndirectHCTab";
import ResetTimeTab from "./tabs/ResetTimeTab";
import FlowPathPercentTab from "./tabs/FlowPathPercentTab";

const SETTINGS_TABS: SettingsTab[] = [
  { id: "ops-clock", label: "OPS Clock", component: OpsClockTab },
  { id: "breaks", label: "Breaks", component: BreaksTab },
  { id: "wip-settings", label: "WIP Settings", component: WipSettingsTab },
  { id: "indirect-hc", label: "Indirect HC", component: IndirectHCTab },
  { id: "flow-path-percent", label: "Flow Path %", component: FlowPathPercentTab },
  { id: "reset-time", label: "Reset Time", component: ResetTimeTab },
];

const Settings: React.FC = () => {
  const [activeTab, setActiveTab] = useState("indirect-hc");

  const ActiveComponent = SETTINGS_TABS.find((t) => t.id === activeTab)?.component;

  return (
    <Box spacingInset="m">
      <Heading level={1}>Settings</Heading>
      <Text color="secondary">
        This page allows you to change labor settings
      </Text>

      <Box spacingInset="300 none">
        <TabGroup value={activeTab} onChange={setActiveTab}>
          {SETTINGS_TABS.map((tab) => (
            <Tab key={tab.id} value={tab.id}>
              {tab.label}
            </Tab>
          ))}
        </TabGroup>
      </Box>

      {ActiveComponent && <ActiveComponent />}
    </Box>
  );
};

export default Settings;
